import { render, staticRenderFns } from "./IconQuantityHi.vue?vue&type=template&id=0a52b642&scoped=true"
import script from "./IconQuantityHi.vue?vue&type=script&lang=js"
export * from "./IconQuantityHi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a52b642",
  null
  
)

export default component.exports